export const initialFilter = {
  driver: null,
  governorates: null,
  districts: null,
  subDistricts: null,
  cities: null,
  isActive: null,
  search: null,
  page: null,
  limit: null,
  sortBy: null,
  sortOrder: null,
};

export const initialErrors = {
  id: null,
  provinces: null,
  cities: null,
  driver: null,
  isActive: null,
};

export type initialErrorsType = typeof initialErrors;

/**
 * An assignment covers exactly one level, so the four level columns this
 * replaced were structurally wrong: three of them were empty on every row.
 * Worse, only two were ever rendered, leaving the District and SubDistrict
 * headers standing over the Driver and Status cells.
 */
export const AreasTableHeader = [
  // Sorting is the server's now, so a column is sortable only where the query
  // has a field to order by. The driver is a reference — ordering on it sorts
  // by id, which is neither alphabetical nor meaningful — and coverage is not
  // one field but five arrays.
  {
    id: 'driver',
    numeric: true,
    label: 'Driver',
    sortable: false,
  },
  {
    id: 'title',
    numeric: true,
    label: 'Title',
  },
  {
    id: 'coverage',
    numeric: true,
    label: 'Coverage',
    sortable: false,
  },
  {
    id: 'isActive',
    numeric: true,
    label: 'Status',
  },
  {
    id: '',
    numeric: false,
    label: '',
  },
];

// How the list is grouped. "By area" is one row per assignment; "By driver"
// collapses them so a driver's whole coverage reads at once — the same records
// asked the other way round.
export const areaGroupings = [
  { label: 'By area', value: 'area' },
  { label: 'By driver', value: 'driver' },
];

// The grouped view. Nothing here is sortable: the rows are built on the
// client from the page the server returned, so a column sort would only
// reorder that page and read as if it had ordered the whole set.
export const DriverAreasTableHeader = [
  {
    id: 'driver',
    numeric: false,
    label: 'Driver',
    sortable: false,
  },
  {
    id: 'coverage',
    numeric: false,
    label: 'Covers',
    sortable: false,
  },
  {
    id: 'count',
    numeric: true,
    label: 'Areas',
    sortable: false,
  },
];

// The status dropdown. "All" is the absence of the filter — the server takes
// `isActive` as a boolean and reads a missing one as both.
export const areaStatuses = [
  { label: 'All', value: 'All' },
  { label: 'Active', value: 'Active' },
  { label: 'Disabled', value: 'Disabled' },
];

export const sortByTypes = [
  { label: 'Created Order', value: '_id' },
  { label: 'Last Update', value: 'updatedAt' },
];

export const sortTypes = [
  { label: 'Asc', value: 'asc' },
  { label: 'Desc', value: 'desc' },
];
